import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  uiTab: {
    minHeight: "calc(100vh - 350px) !important",
    height: "100% !important",
  },
  suppliersTab: {
    fontFamily: "Manrope !important",
    padding: "32px",
    overflowX: "hidden",
    overflowY: "hidden",
  },
  maintenanceTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  statusText: {
    fontFamily: "Manrope !important",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "16px",
    fontSize: "12px",
    marginRight: "8px !important",
  },
  titleRight: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  badge: {
    height: "24px",
  },
}));

export default styles;
